<template>
    <label class="view-upload-image" :class="classNames" ref="elm">
        <input
            type="file"
            ref="file"
            @change="changeImage"
            :multiple="multiple"
        />
        <img :src="this.url" alt="" v-if="url && !failure && !pending" />
        <div class="loading-view" v-else-if="pending"></div>
        <div class="error-view" v-else-if="failure">
            <i class="icon-image-error"></i>
            <div class="hint-text">图片上传错误</div>
        </div>
        <div class="empty-view" v-else>点击上传图片</div>
    </label>
</template>
<script>
import _ from 'lodash';
import config from 'utils/config';
import { convertImage } from 'utils/helper';
import uploadMinxis from './uploadMinxis';
import upload from 'mixins/upload';
export default {
    mixins: [upload, uploadMinxis],
    props: {
        url: String,
        multiple: Boolean,
        autoUpload: Boolean,
        index: Number
    },
    data: function() {
        return {
            image: null,
            pending: false,
            failure: false
        };
    },
    mounted() {
        this.loadImage();
        console.log('mounted', this.index);
    },
    beforeDestroy() {
        this.clearItem();
    },
    computed: {
        classNames() {
            return {
                pending: this.pending,
                error: this.failure
            };
        },
        imageStyle() {
            if (this.url) {
                var style = {
                    backgroundImage: `url(${this.url})`
                };
                return style;
            } else {
                return {};
            }
        }
    },
    methods: {
        loadImage() {
            if (this.url) {
                this.pending = true;
                this.image = new Image();
                this.image.onload = this.loadImageComplete;
                this.image.onerror = this.loadImageFailure;
                this.image.src = this.url;
            } else {
                this.image = null;
            }
        },
        loadImageComplete() {
            this.pending = false;
            this.failure = false;
        },
        loadImageFailure() {
            this.pending = false;
            this.failure = true;
        },
        clearItem() {
            if (this.image) {
                this.image = null;
            }
        },
        clearFile() {
            this.$refs.file.value = '';
        },
        changeImage(e) {
            const files = e.target.files;
            this.$emit('change', files);
            if (this.autoUpload) {
                _.each(files, item => {
                    this.handleUploadImage(item)
                        .then(url => {
                            this.$emit('success', url);
                        })
                        .catch(e => {
                            this.failure = true;
                            console.log(e);
                        });
                });
            }
        }
    },
    watch: {
        url() {
            this.loadImage();
        }
    }
};
</script>

<style lang="scss" scoped>
.form-field {
    align-items: flex-start;
}

.loading-view {
    background: #ccc;
}

.view-upload-image {
    width: 100px;
    display: inline-block;
    position: relative;
    color: #bebebe;
    cursor: pointer;
    height: 100px;
    min-height: 100px;
    // margin-top: 50px;
    margin-bottom: 20px;
    border-radius: 6px;
    overflow: hidden;
    // float: right;
    input {
        display: none;
    }
    .tooltip {
        color: #fff;
        font-size: 12px;
        line-height: 20px;
        height: 20px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        background: rgba(0, 0, 0, 0.7);
    }
    > img {
        width: 100%;
        height: 100%;
    }
    > .empty-view,
    > .error-view {
        width: 100%;
        height: 100%;
        background: #f9f9f9;
        cursor: pointer;
        text-align: center;
        min-height: 100px;
    }
    > .empty-view {
        border-radius: 6px;
        background: #fff !important;
        position: relative;
        box-sizing: border-box;
        border: 1px solid #ddd;
        line-height: 100px;
    }
    > .loading-view {
        width: 100%;
        height: 100%;
        cursor: pointer;
    }

    &.error {
        > .empty-view {
            background: rgba(255, 0, 0, 0.4) !important;
            border: dashed 1px red;
            > .mu-icon {
                color: red;
            }
        }
    }
}
</style>
